import { FloatButton, Tour, type TourProps } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import './style.scss'

interface GuidedTourProps {
    tourAberto: boolean;
    abrirTour: () => void;
    fecharTour: () => void;
    passos: TourProps['steps'];
    rotuloBotaoAjuda?: string;
}

export const GuidedTour = ({
    tourAberto,
    abrirTour,
    fecharTour,
    passos,
    rotuloBotaoAjuda = 'Ver passo a passo',
}: GuidedTourProps) => {
    if (!passos?.length) return null

    return (
        <>
            <FloatButton
                icon={<QuestionCircleOutlined />}
                tooltip={{ title: rotuloBotaoAjuda, placement: 'left' }}
                onClick={abrirTour}
                className="float-button-top-one-class"
                style={{ insetBlockStart: 80, insetBlockEnd: 'auto', insetInlineEnd: 10 }}
                aria-label={rotuloBotaoAjuda}
            />
            <Tour
                open={tourAberto}
                onClose={fecharTour}
                onFinish={fecharTour}
                steps={passos}
                rootClassName="guided-tour-root-class"
            />
        </>
    )
}
